import React from 'react';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckIcon from '@material-ui/icons/Check';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { COOL_BLUE } from 'colours';

export default function Checkbox(props) {
  const checkBoxStyles = makeStyles(() => ({
    checked: {},
    icon: {
      width: props.width ? props.width : 16,
      height: props.height ? props.height : 16,
      color: props.color ? props.color : COOL_BLUE,
      borderRadius: '5px',
      border: '3px solid',
    },
    checkedIcon: {
      width: props.width ? props.width : 16,
      height: props.height ? props.height : 16,
      backgroundColor: props.color ? props.color : COOL_BLUE,
      color: props.colorSelected ? props.colorSelected : '#ffffff',
      borderRadius: '5px',
      border: '3px solid ' + (props.color ? props.color : COOL_BLUE),
    },
  }));

  const checkboxClasses = checkBoxStyles();

  const onCheckboxChange = val => {
    if (props.onCheckboxChange) {
      props.onCheckboxChange(val.target.value, val.target.checked);
    }
  };

  return (
    <FormControlLabel
      control={
        <MaterialCheckbox
          classes={checkboxClasses.root}
          checked={props.checked}
          id={props.value}
          value={props.value}
          name={props.type}
          disabled={props.disabled}
          icon={<span className={checkboxClasses.icon} />}
          checkedIcon={
            <CheckIcon
              className={clsx(
                checkboxClasses.icon,
                checkboxClasses.checkedIcon
              )}
            />
          }
          onChange={e => onCheckboxChange(e)}
        />
      }
      label={props.label}
      labelPlacement={props.labelPlacement}
    />
  );
}

Checkbox.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  icon: PropTypes.node,
  checkedIcon: PropTypes.node,
  onCheckboxChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelPlacement: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),
};
